import type { LucideIcon } from 'lucide-react';
import type { ReactNode } from 'react';

import { cn } from '@nucleus-commerce/ui/lib/utils';

import { RouteTourLink } from '../tour/components/route-tour-link';

export interface EmptyStateProps {
  icon?: LucideIcon;
  title: ReactNode;
  description?: ReactNode;
  /** Primary call to action. */
  action?: ReactNode;
  className?: string;
  /** `data-tour` value when a guided tour points at this empty state. */
  tour?: string;
  /** List pages: offer "Take a 1-minute tour of this page" under the action. */
  tourLink?: boolean;
}

export function EmptyState({
  icon: Icon,
  title,
  description,
  action,
  className,
  tour,
  tourLink = false,
}: EmptyStateProps) {
  return (
    <div
      data-tour={tour}
      className={cn(
        'flex flex-col items-center justify-center gap-3 rounded-lg border border-dashed p-10 text-center',
        className,
      )}
    >
      {Icon ? (
        <div className="bg-muted text-muted-foreground flex size-12 items-center justify-center rounded-full">
          <Icon className="size-6" aria-hidden />
        </div>
      ) : null}
      <div className="space-y-1">
        <h2 className="text-base font-medium">{title}</h2>
        {description ? (
          <p className="text-muted-foreground max-w-md text-sm">{description}</p>
        ) : null}
      </div>
      {action ? <div className="pt-1">{action}</div> : null}
      {tourLink ? <RouteTourLink /> : null}
    </div>
  );
}
